import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { SectionTitle } from "@/components/common";
import { TripForm } from "@/components/TripForm";
import { api } from "@/lib/api";

export default function NewTrip() {
  const nav = useNavigate();
  const create = async (body) => {
    const { data } = await api.post("/trips", body);
    toast.success("Trip created! Next: invite your travelers.");
    nav(`/trips/${data.trip_id}`);
  };
  return (
    <div className="mx-auto max-w-2xl">
      <SectionTitle title="Plan a new trip" sub="Only the name is required — fill in the rest whenever you know it." />
      <div className="card p-6"><TripForm onSubmit={create} submitLabel="Create trip" /></div>
    </div>
  );
}
